(() => {
  const positionKey = 'berries:collection-tabs-position';

  function savePosition(event) {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const link = event.target.closest('.UiCollectionTabs__link');
    const navigation = link && link.closest('[data-collection-tabs-navigation]');
    if (!navigation || navigation.closest('.DesignSystem')) return;

    const destination = new URL(link.href, window.location.href);
    if (destination.origin !== window.location.origin || destination.pathname === window.location.pathname) return;

    try {
      sessionStorage.setItem(positionKey, JSON.stringify({
        path: destination.pathname,
        top: navigation.getBoundingClientRect().top,
        savedAt: Date.now()
      }));
    } catch (_) {
      // Navigation still works when session storage is unavailable.
    }
  }

  function restorePosition() {
    let saved;
    try {
      saved = JSON.parse(sessionStorage.getItem(positionKey) || 'null');
      sessionStorage.removeItem(positionKey);
    } catch (_) {
      return;
    }

    if (!saved || saved.path !== window.location.pathname || Date.now() - saved.savedAt > 15000) return;
    const navigation = document.querySelector('[data-collection-tabs-navigation]');
    if (!navigation || !Number.isFinite(saved.top)) return;

    const target = window.scrollY + navigation.getBoundingClientRect().top - saved.top;
    window.scrollTo({ top: Math.max(0, target), behavior: 'instant' });
  }

  function revealLink(link) {
    const viewport = link.closest('.UiCollectionTabs__viewport');
    if (!viewport) return;

    const viewportBounds = viewport.getBoundingClientRect();
    const linkBounds = link.getBoundingClientRect();

    if (linkBounds.right > viewportBounds.right) {
      viewport.scrollLeft = Math.min(
        viewport.scrollWidth - viewport.clientWidth,
        viewport.scrollLeft + linkBounds.right - viewportBounds.right + 16
      );
    } else if (linkBounds.left < viewportBounds.left) {
      viewport.scrollLeft -= viewportBounds.left - linkBounds.left;
    }
  }

  function revealCurrent(root) {
    root.querySelectorAll('.UiCollectionTabs').forEach((navigation) => {
      const current = navigation.querySelector('[aria-current="page"]');
      if (current) revealLink(current);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => requestAnimationFrame(() => revealCurrent(document)), { once: true });
  } else {
    requestAnimationFrame(() => revealCurrent(document));
  }

  document.addEventListener('shopify:section:load', (event) => revealCurrent(event.target));
  document.addEventListener('click', savePosition, { capture: true });
  document.addEventListener('focusin', (event) => {
    if (event.target.matches('.UiCollectionTabs__link')) revealLink(event.target);
  });

  if (document.readyState === 'complete') {
    requestAnimationFrame(restorePosition);
  } else {
    window.addEventListener('load', () => requestAnimationFrame(restorePosition), { once: true });
  }
})();
